const mapDivisionToLibrary = {
  ELT: 'elt',
  EXAMPLE: 'regression'
};

export default mapDivisionToLibrary;
